// extracted by mini-css-extract-plugin
module.exports = {"cell":"HistoryEventTypeCell-cell-3-sGe TableRowCell-cell-2fbg4"};